import React from 'react';

// eslint-disable-next-line import/extensions
import config from '../../config';

const UserHeader: React.FC = () => {
  return (
    <div className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <span className={`mask bg-gradient-${config.class} opacity-8`} />
    </div>
  );
};

export default UserHeader;
